import { render, staticRenderFns } from "./RejectPage.vue?vue&type=template&id=3970a196&scoped=true&"
import script from "./RejectPage.vue?vue&type=script&lang=ts&"
export * from "./RejectPage.vue?vue&type=script&lang=ts&"
import style0 from "./RejectPage.vue?vue&type=style&index=0&id=3970a196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3970a196",
  null
  
)

export default component.exports